/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'tagAlert': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<g _fill="#686a7a"><path pid="0" d="M10 16.667a.831.831 0 0 0 .59-.245l5.833-5.833a.832.832 0 0 0 0-1.178L7.256.244A.83.83 0 0 0 6.666 0H.834A.833.833 0 0 0 0 .833v5.834a.83.83 0 0 0 .244.589l9.167 9.166a.831.831 0 0 0 .59.245ZM14.655 10 10 14.655 1.667 6.322V1.667h4.655L14.655 10Z"/><path pid="1" d="M4.166 5.833a1.667 1.667 0 1 1 0-3.333 1.667 1.667 0 0 1 0 3.333ZM18.333 11.666H20v5h-1.667v-5ZM19.167 19.167a.833.833 0 1 1 0-1.667.833.833 0 0 1 0 1.667Z"/></g>'
  }
})
